import React from "react";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";

interface Props extends WithStyles<typeof styles> {
	/** Hidden when zero. */
	count: number;
}

const Component: React.FC<Props> = ({ count, classes = {} }) => {
	if (!count) {
		return null;
	}
	return (
		<span className={classes.badge} aria-label={`${count} pending`}>
			{count}
		</span>
	);
};

export const TabBadge = withStyles(Component, styles);
